module.exports = __webpack_public_path__ + "static/img/sishangqy.16f900d8.png";